import { memo } from 'react';
import { Box } from '@material-ui/core';
import {
  SCheckbox,
  SETVIImage,
  SHighlightText
} from '@setvi/shared/components';
import { facetOptionHeight } from '../../..';
import { CountChip } from '../standard-list';

interface CertificationProps {
  item: string;
  count?: number;
  searchQuery?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isChecked: boolean;
}

const getItemName = (item: string) => {
  if (item === 'true') return 'Yes';
  if (item === 'false') return 'No';

  return item;
};

export const CertificationList = memo(
  ({
    item,
    count,
    searchQuery,
    onChange,
    isChecked = false
  }: CertificationProps) => {
    const facet = item.split(';');
    return (
      <Box display="flex" alignItems="center" my="12px">
        <SCheckbox
          size="small"
          color="primary"
          checked={isChecked}
          onChange={onChange}
        />
        <Box
          ml={2}
          flex={1}
          display="flex"
          alignItems="center"
          justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <Box
              height={facetOptionHeight}
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{
                maxWidth: '24px',
                overflow: 'hidden',
                borderRadius: '50%',
                padding: 2,
                marginRight: '10px',
                border: '1px solid #EEF0F2'
              }}>
              <SETVIImage
                width="100%"
                height="100%"
                src={facet[2]}
                alt={facet[1]}
              />
            </Box>

            <SHighlightText
              style={{
                maxWidth: 145,
                minWidth: 80,
                width: '100%'
              }}
              size="sm"
              lineHeight="20px"
              searchQuery={searchQuery}
              value={getItemName(facet[1])}
            />
          </Box>

          {count && <CountChip>{count}</CountChip>}
        </Box>
      </Box>
    );
  }
);
